<script lang="ts">
    import { fade, fly } from "svelte/transition";
    import { CheckIcon } from "svelte-feather-icons";
    import type { AnsweredQuestions, QuestionCollection } from "../questions";
    import * as Questions from "../questions";
    import QuestionComponent from "./QuestionComponent.svelte";
    import type { SearchResult } from "../search";

    export let collection: QuestionCollection;
    export let resorts: SearchResult[];
    const questions = collection.questions;
    const structure = collection.structure;

    export let onChange: ((answeredQuestions: AnsweredQuestions) => void) | null;
    export let onSave: (() => void) | null;

    export let answered: AnsweredQuestions;
    answered.addDefaultAnswers(collection);

    const submit = () => {
        if (onChange !== null) {
            onChange(answered);
        }
    };
</script>

<div class="question-overview">
    {#each questions as question}
        {#if !question.only_in_quiz}
            <QuestionComponent
                {resorts}
                {question}
                answer={answered.getByID(question.id).answer || undefined}
                {answered}
                onChange={(newAnswer) => {
                    answered.getByID(question.id).answer = newAnswer;
                    submit();
                }}
            />
        {/if}
    {/each}
    <button
        class="save"
        on:click={() => {
            if (onSave != null) onSave();
        }}
    >
        Spara
        <CheckIcon />
    </button>
</div>
